import { create } from 'zustand';

// Bouton suivant
export const useSavingStore = create((set) => ({
  pendingSaves: 0,
  startSave: () =>
    set(({ pendingSaves }) => ({ pendingSaves: pendingSaves + 1 })),
  endSave: () =>
    set(({ pendingSaves }) => ({
      pendingSaves: Math.max(0, pendingSaves - 1)
    }))
}));
